import type { SpaceAdapterRuntimeController } from '@toolproof-core/visualization/adapter/_contract/runtime';

import type { Config, CosmosDataModel, RuntimeState } from '@/adapters/episode/_contract/config';

export const runtimeController: SpaceAdapterRuntimeController<Config, RuntimeState, CosmosDataModel> = {
    createInitialRuntimeState: () => ({}),
    buildOverlayModel: ({ cosmosData }) => ({
        overlayId: 'episode-space',
        title: 'Episodes',
        subtitle: `${cosmosData.rings.reduce((count, ring) => count + ring.episodes.length, 0)} episodes in `
            + `${cosmosData.rings.filter((ring) => ring.episodes.length > 0).length} spaces`,
        sections: [],
    }),
};
